module.exports = __webpack_public_path__ + "media/images/rent-a3bbcb161a7c039b3d0f7ffae7718430.svg";